const questions = require('../data/questions.json').questions;

export default class QuestionRepository {
    constructor() {
        this.questions = questions;
    }

    getQuestionById(id) {
        return this.questions.find((item) => item.id === id);
    }

    getQuestionValueById(id) {
        const question = this.getQuestionById(id);

        return question.question;
    }

    getFirstQuestions() {
        return this.questions.filter((item) => String(item.id).endsWith('.1'));
    }

    getAllQuestionsStartingWith(idStartsWith) {
        return this.questions.filter((item) => String(item.id).startsWith(String(idStartsWith)));
    }
}
